<template>
  <div v-if="totalPage > 0" class="aiz-pagination aiz-pagination-center mt-4">
    <nav>
      <ul class="pagination">
        <li
          :class="{ disabled: curPage === 1 }"
          class="page-item"
          @click="goToPage(curPage - 1)"
        >
          <span class="page-link">‹</span>
        </li>

        <li
          v-for="(page, index) in pageItemList"
          :key="index"
          :class="{
            active: page === curPage,
            disabled: page === '...'
          }"
          class="page-item"
          @click="goToPage(page)"
        >
          <span class="page-link">{{ page }}</span>
        </li>

        <li
          :class="{ disabled: curPage === totalPage }"
          class="page-item"
          @click="goToPage(curPage + 1)"
        >
          <span class="page-link">›</span>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  props: {
    totalPage: Number,
    curPage: Number
  },
  computed: {
    pageItemList() {
      if (this.totalPage <= 10) {
        return this.createNumberArray(1, this.totalPage);
      } else if (this.curPage <= 5 || this.curPage >= this.totalPage - 4) {
        return [
          ...this.createNumberArray(1, 5),
          "...",
          ...this.createNumberArray(this.totalPage - 4, this.totalPage)
        ];
      } else {
        return [
          ...this.createNumberArray(1, 2),
          "...",
          ...this.createNumberArray(this.curPage - 2, this.curPage + 2),
          "...",
          ...this.createNumberArray(this.totalPage - 1, this.totalPage)
        ];
      }
    }
  },
  methods: {
    createNumberArray(start, end) {
      const list = [];
      for (let i = start; i <= end; i++) {
        list.push(i);
      }
      return list;
    },
    goToPage(page) {
      this.$emit("goto", page);
    }
  }
};
</script>
